import { render, staticRenderFns } from "./PartnerProductForm.vue?vue&type=template&id=52be01e4&scoped=true"
import script from "./PartnerProductForm.vue?vue&type=script&lang=js"
export * from "./PartnerProductForm.vue?vue&type=script&lang=js"
import style0 from "./PartnerProductForm.vue?vue&type=style&index=0&id=52be01e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_f8be560a05ba39e4779a4b3800f88bf1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52be01e4",
  null
  
)

export default component.exports